/**
 * Type of acknowledgement.
 * tag: 1503
 * @readonly
 * @enum {number} (int)
 */
export enum StreamAsgnAckType {
  /** Assignment Accepted */
  AssignmentAccepted = 0,
  /** Assignment Rejected */
  AssignmentRejected = 1,
}
